import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { BookOpen, Lock, CheckCircle2 } from "lucide-react";

export default function MyReadings() {
  const navigate = useNavigate();
  const [readings, setReadings] = useState(null);
  const [filter, setFilter] = useState("all");

  useEffect(() => { api.get("/readings").then(({ data }) => setReadings(data)).catch(() => setReadings([])); }, []);

  if (readings === null) return <div className="mx-auto max-w-3xl px-5 py-20"><div className="h-40 rounded-2xl bg-muted shimmer" /></div>;

  const shown = readings.filter((r) => filter === "all" || (filter === "purchased" && r.paid) || (filter === "saved" && r.saved));

  return (
    <div className="mx-auto max-w-3xl px-5 pt-8 md:pt-12">
      <h1 className="font-display text-3xl font-semibold tracking-tight md:text-4xl">My Readings</h1>
      <div className="mt-6 flex gap-2">
        {["all", "purchased", "saved"].map((f) => (
          <button key={f} data-testid={`readings-filter-${f}`} onClick={() => setFilter(f)}
            className={`rounded-full border px-4 py-1.5 text-sm capitalize btn-lift ${filter === f ? "bg-foreground text-background" : "bg-card"}`}>{f}</button>
        ))}
      </div>

      {shown.length === 0 ? (
        <div className="mt-16 flex flex-col items-center text-center" data-testid="readings-empty">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gold-soft"><BookOpen className="h-7 w-7 gold-text" /></div>
          <h2 className="mt-5 font-display text-xl font-semibold">No readings yet</h2>
          <p className="mt-1 max-w-xs text-sm text-muted-foreground">Ask your first question and your readings will appear here.</p>
          <button onClick={() => navigate("/")} className="mt-6 rounded-full bg-foreground px-6 py-2.5 text-sm text-background btn-lift">Ask a question</button>
        </div>
      ) : (
        <div className="mt-6 space-y-3">
          {shown.map((r) => (
            <button key={r.reading_id} data-testid={`reading-item-${r.reading_id}`} onClick={() => navigate(r.paid ? `/reading/${r.reading_id}` : `/teaser/${r.reading_id}`)}
              className="card-soft flex w-full items-center justify-between gap-4 rounded-2xl p-5 text-left btn-lift">
              <span>
                <div className="font-medium">{r.question}</div>
                <div className="mt-1 text-xs text-muted-foreground">{r.category} • {new Date(r.created_at).toLocaleDateString()}</div>
              </span>
              <span className={`flex shrink-0 items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ${r.paid ? "bg-green-100 text-green-700" : "bg-muted text-muted-foreground"}`}>
                {r.paid ? <><CheckCircle2 className="h-3.5 w-3.5" /> Unlocked</> : <><Lock className="h-3.5 w-3.5" /> ₹{r.price}</>}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
